// src/views/orders/Create/OrderStatusSection.jsx
import React from 'react'
import { CFormCheck } from '@coreui/react'

const OrderStatusSection = ({
  inputList,
  orderStatus,
  errorList,
  onRadioChange,
  onCheckChange,
  onCompleteToggle,
  onCancelledToggle,
  onDateChange,
}) => {
  const isCancelled = Number(inputList.order_status) === 3
  const isCompleted = Number(inputList.order_status) === 1

  return (
    <div className="row mb-3">
      <h5>Order Status</h5>

      <div className="col">
        <span>Order ID: {inputList.order_id}</span>
        <br />
        <span>Status: {orderStatus}</span>
        <br />
        <span>Created At: {inputList.created_at}</span>

        <CFormCheck
          id="order-cancelled-switch"
          name="order_status"
          className="mt-2"
          label="Cancelled"
          onChange={onCancelledToggle}
          checked={isCancelled}
        />
      </div>

      <div className="col">
        <CFormCheck
          type="radio"
          name="dockets_ready"
          label="Deselect"
          value="0"
          checked={inputList.dockets_ready === '0'}
          onChange={onRadioChange}
          disabled={isCancelled}
        />

        <CFormCheck
          type="radio"
          name="dockets_ready"
          label="New"
          value="3"
          checked={inputList.dockets_ready === '3'}
          onChange={onRadioChange}
          disabled={isCancelled}
        />

        <CFormCheck
          type="radio"
          name="dockets_ready"
          label="Ready"
          value="1"
          checked={inputList.dockets_ready === '1'}
          onChange={onRadioChange}
          disabled={isCancelled}
        />

        <CFormCheck
          type="radio"
          name="dockets_ready"
          label="Will Advise"
          value="2"
          checked={inputList.dockets_ready === '2'}
          onChange={onRadioChange}
          disabled={isCancelled}
        />
      </div>

      <div className="col">
        <CFormCheck
          name="tons_complete"
          label="Tons Complete"
          checked={inputList.tons_complete === '1'}
          onChange={onCheckChange}
          disabled={isCancelled}
        />

        {inputList.tons_complete_time && (
          <input
            type="date"
            name="tons_complete_time"
            className="form-control w-50 ms-2"
            value={inputList.tons_complete_time}
            onChange={onDateChange}
            disabled={isCancelled}
          />
        )}

        <span className="text-danger">{errorList['tons_complete']}</span>

        <CFormCheck
          name="dockets_complete"
          className="mt-2"
          label="Dockets Complete"
          checked={inputList.dockets_complete === '1'}
          onChange={onCheckChange}
          disabled={isCancelled}
        />

        {inputList.dockets_complete_time && (
          <input
            type="date"
            name="dockets_complete_time"
            className="form-control w-50 ms-2"
            value={inputList.dockets_complete_time}
            onChange={onDateChange}
            disabled={isCancelled}
          />
        )}

        <span className="text-danger">{errorList['dockets_complete']}</span>

        <CFormCheck
          className="mt-2"
          id="order-status-switch"
          name="order_status"
          label="Completed"
          onChange={onCompleteToggle}
          checked={isCompleted}
          disabled={isCancelled}
        />
      </div>

      <div className="col">
        <div className="form-group">
          <label className="pb-2">Scheduled Date</label>
          <input
            type="date"
            name="scheduled_date"
            className="form-control"
            value={inputList.scheduled_date || ''}
            onChange={onDateChange}
            disabled={isCancelled}
          />
          <span className="text-danger">{errorList['scheduled_date']}</span>
        </div>

        <div className="form-group">
          <label className="mt-2 pb-2">Scheduled Note</label>
          <input
            type="text"
            name="scheduled_note"
            className="form-control"
            value={inputList.scheduled_note || ''}
            onChange={onDateChange}
            disabled={isCancelled}
          />
          <span className="text-danger">{errorList['scheduled_note']}</span>
        </div>
      </div>
    </div>
  )
}

export default OrderStatusSection
